/**
 * @description 腾讯视频iPad端方法实现
 * @author aprilcai
 */

import { resultCode, resultMessage, wrapResult } from '../module/entity';
import { invokeAsync } from '../module/bridge';
import {
  mobileLogin,
  mobileAccessLocal,
  mobileClose,
  mobileGetUserInfo,
  mobileGetDeviceId,
  mobileGetNetworkState,
  mobileOpenWebview,
  mobileOpenPayPage,
  mobileShare,
  mobileWriteLog,
  mobileOpenPayVipView,
  mobileToast,
} from './pad-phone-common-method';
import { isTenvideoPad } from '../module/ua';

// 当前webview是否支持
export function support() {
  return isTenvideoPad;
}

// 登录
export async function login(): Promise<IResult> {
  return mobileLogin();
}

// 退出登录
export async function logout(): Promise<IResult> {
  const res = await invokeAsync('openLogoutView', null);
  const { errCode, errMsg } = res;
  return wrapResult(errCode, errMsg);
}

// 是否登录
export async function isLogin(): Promise<IResult> {
  const res = await invokeAsync('getMainLogin', null);
  const { errCode, errMsg, result } = res;
  return wrapResult(errCode, errMsg, {
    isLogin: result === 'qq' || result === 'wx',
  });
}

// 本地存储
export async function accessLocal(param: {
  type: string;
  key: string;
  value: string;
}): Promise<IResult> {
  return mobileAccessLocal(param);
}

// 关闭
export async function close(): Promise<IResult> {
  return mobileClose();
}

// 获取用户信息
export async function getUserInfo(param: { data: any; isTest: false }): Promise<IResult> {
  return mobileGetUserInfo(param);
}

// t设备id
export async function getDeviceId(): Promise<IResult> {
  return mobileGetDeviceId();
}

// 获取网络状态
export async function getNetworkState(): Promise<IResult> {
  return mobileGetNetworkState();
}

// 打开webview
export async function openWebview(param: {
  url: string;
  close?: number;
  style?: number;
}): Promise<IResult> {
  return mobileOpenWebview(param);
}

// 打开支付页
export async function openPayPage(param: {
  appid?: string;
  actid?: string;
  orderid?: string;
  needpay?: string;
  close?: number;
  ru?: string;
  title?: string;
  sandbox?: number;
  autopay?: number;
}): Promise<IResult> {
  return mobileOpenPayPage(param);
}

// 刷新标题
export async function refreshTitle(param: { title: string }): Promise<IResult> {
  const { title } = param;
  document.title = title;
  const iframe = document.createElement('iframe');
  iframe.src = '/favicon';
  iframe.style.display = 'none';
  iframe.onload = () => {
    setTimeout(() => {
      iframe.remove();
    }, 9);
  };
  document.body.appendChild(iframe);
  return wrapResult(resultCode.ok, resultMessage.ok);
}

// 分享
export async function share(param: {
  title: string;
  subTitle?: string;
  url: string;
  imageUrl: string;
  sharePageTitle?: string;
  sharePageLaunchUrl?: string;
}): Promise<IResult> {
  return mobileShare(param);
}

// 写日志
export async function writeLog(param: {
  appid: string;
  content: string;
  isReportServer: boolean;
  isConsoleLog: boolean;
}): Promise<IResult> {
  return mobileWriteLog(param);
}

// 打开VIP开通页/浮层
export async function openPayVipView(param: { url?: string }) {
  return mobileOpenPayVipView({
    url: param.url,
  });
}

// toast
export async function toast(content: string) {
  return mobileToast(content);
}
